// @flow
import * as yup from "yup";

// eslint-disable-next-line no-unused-vars
import schemaErrorMessages from "../../../utils/schemaErrorMessages";

const getPolygonSchema: Object = yup.object().shape({
  type: yup.string().required(),
  features: yup.array().of(
    yup.object().shape({
      type: yup.string().required(),
      geometry: yup.object().shape({
        type: yup.string(),
        coordinates: yup.array(),
      }),
      properties: yup.object().shape({
        id: yup.string().nullable(),
        code: yup.string().nullable(),
        name: yup.string().nullable(),
        type: yup.string().nullable(),
      }),
    })
  ),
});

export default getPolygonSchema;
